import React from "react";
import { useLocation } from "react-router-dom";
// import "../assets/styles/components/VistaProductoNFT.css";
import tensoBlockNovedadBackground from "../assets/images/maqueta//tenso-nft/bloque-h.svg";
import viguetaNovedadBackground from "../assets/images/maqueta/tenso-nft/m-producto.svg";

const NFTcards = [
  {
    title: "NFTBlock",
    background_card: `${tensoBlockNovedadBackground}`,
    descripcion: "Unidades de un sistema constructivo más ágil, eficiente y económico que el tradicional. Al ser de hormigón vibrocomprimido de alta calidad, pueden trabajar como encofrados perdidos para construir columnas y vigas en su interior, además de poder insertar las instalaciones logrando una construcción más prolija sin necesidad de romper material.",
    price_eth: "0.15",
    price_usd: "251",
  },
  {
    title: "NFTViguT21",
    background_card: `${viguetaNovedadBackground}`,
    descripcion: "Unidades de un sistema constructivo más ágil, eficiente y económico que el tradicional. Al ser de hormigón vibrocomprimido de alta calidad, pueden trabajar como encofrados perdidos para construir columnas y vigas en su interior, además de poder insertar las instalaciones logrando una construcción más prolija sin necesidad de romper material.",
    price_eth: "0.12",
    price_usd: "231",
  },
];

const VistaProductoNFT = () => {
  const location = useLocation();
  console.log(location.state.producto); // aqui recibimos el llamado a galeria para armar el pedido a DB de las imagenes que necesitamos

  const productoSeleccionado = NFTcards.filter(
    (item) => item.title === location.state.producto
  )[0];
  console.log(productoSeleccionado);
  return (
    <div className="main-nft">
      <div className="container main-section--vista_nft">
        <div className="img-nft--container">
          <figure>
            <img
              src={productoSeleccionado.background_card}
              alt={`${productoSeleccionado.title}`}
            />
          </figure>
        </div>
        <div className="info--container">
          <div className="descrpcion--container">
            <h2>{productoSeleccionado.title}</h2>
            <p>
              {productoSeleccionado.descripcion}
            </p>
          </div>
          <div className="includes--container">
            <h5>includes</h5>
            <ul>
              <li> Acceso a eventos </li>
              <li> Puedes quemar tu NFT por un producto fisico</li>
            </ul>
          </div>
          <div className="price--container">
            <h5>precios</h5>
            <div className="currency--container">
              <p className="price">{productoSeleccionado.price_eth} ETH</p>
              <p className="price">~ u$s {productoSeleccionado.price_usd}</p>
            </div>
          </div>
          <div className="button-container">
            <button>open sea</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VistaProductoNFT;
